// AuthForm.js
import React, { useState } from 'react';

const AuthForm = ({ isLoginMode, onSubmit }) => {  // Убираем setUser, добавляем onSubmit
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Вызываем onSubmit и передаем данные формы
      await onSubmit({ email, password });
    } catch (error) {
      setMessage('Ошибка: не удалось выполнить действие');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input class="search-input"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
        required
      />
      <input class="search-input"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Пароль"
        required
      />
      <button type="submit" class="glow-on-hover2">{isLoginMode ? 'Войти' : 'Зарегистрироваться'}</button>
      {message && <p>{message}</p>}
    </form>
  );
};

export default AuthForm;
